import PropTypes from 'prop-types';

import SchemaJsonLd from './SchemaJsonLd';

const ItemListJsonLd = ({
  id,
  description,
  items,
  listOrder = 'ascending',
  name,
  renderItemAsSchema,
}) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name,
    description,
    itemListOrder: listOrder,
    numberOfItems: items.length,
    itemListElement: items.map(renderItemAsSchema),
  };

  return <SchemaJsonLd id={id} schema={schema} />;
};

ItemListJsonLd.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  listOrder: PropTypes.string,
  name: PropTypes.string.isRequired,
  renderItemAsSchema: PropTypes.func.isRequired,
};

export default ItemListJsonLd;
